export default __webpack_public_path__ + "static/media/grognak-round-icon.05b9dad2.svg";